import axios from "axios";
import { dbService } from "../firebaseInstance";

// Firebase Functions (Cloud Run) API 엔드포인트 (api-rules.mdc 업데이트 반영)
const postThreadUrl = "https://postthread-rwo7wzkzaa-uc.a.run.app";
const createTaskUrl = "https://createtask-rwo7wzkzaa-uc.a.run.app";
const listTaskUrl = "https://listtasks-rwo7wzkzaa-uc.a.run.app";
const deleteTaskUrl = "https://deletetask-rwo7wzkzaa-uc.a.run.app";
const updateTaskUrl = null; // 수정 API는 규칙에 없으므로 null 처리 (실제 엔드포인트가 있다면 해당 URL로 변경)

// 1. 즉시 스레드 게시 - tokenManager 활용
export const postThread = async (text, replies = [], media = [], firestoreTaskId = null) => {
	const userID = localStorage.getItem("userID");
	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	try {
		// tokenManager를 통해 유효한 토큰 획득
		const { getValidTokenForAPI } = await import('./tokenUtils');
		const token = await getValidTokenForAPI(userID);
		
		console.log("Using long-lived token for postThread:", "userID", userID);

		const payload = {
			userID: userID,
			token: token,
			text: text,
			replies: replies,
			media: media,
		};
		if (firestoreTaskId) {
			payload.firestoreTaskId = firestoreTaskId;
		}
		const response = await axios.post(
			postThreadUrl,
			payload,
			{ timeout: (Array.isArray(media) && media.length > 0) ? 600000 : 30000 }
		);
		const result = response.data || {};
		result.__httpStatus = response.status;
		return result;
	} catch (error) {
		console.error("Error posting thread immediately:", error.response ? error.response.data : error.message);
		throw error;
	}
};

/**
 * @deprecated HTTP API 방식 - 사용하지 않음
 * Firestore 트리거 방식으로 대체됨: createFirestoreTask() 사용
 * 코드 보존 이유: 폴백 및 참고용
 */
export const createTask = async ({ text, executeAt, replies = [], media = [] }) => {
	const userID = localStorage.getItem("userID");
	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	try {
		// tokenManager를 통해 유효한 토큰 획득
		const { getValidTokenForAPI } = await import('./tokenUtils');
		const token = await getValidTokenForAPI(userID);
		
		console.log("Using long-lived token for createTask:", "userID", userID);

		const response = await axios.post(createTaskUrl, {
			userID: userID,
			token: token,
			text: text,
			url: postThreadUrl, // API 문서에 따라 post할 URL 전달
			executeAt: executeAt, // KST 시간 문자열 전달
			replies: replies,
			media: media,
		});
		const result = response.data || {};
		result.__httpStatus = response.status;
		return result;
	} catch (error) {
		console.error("Error creating scheduled task:", error.response ? error.response.data : error.message);
		throw error;
	}
};

/**
 * @deprecated HTTP API 방식 - 사용하지 않음
 * Firestore 실시간 구독으로 대체됨: useActiveTasksSubscription() 훅 사용
 */
export const getScheduledPosts = async () => {
	try {
		const response = await axios.get(listTaskUrl);
		console.log("getScheduledPosts response data:", response.data);
		
		// Cloud Tasks API 응답 구조: { code: 200, message: "SUCCESS", now: timestamp, data: [...] }
		if (response.data && response.data.code === 200 && response.data.data) {
			// data 배열에서 각 작업의 정보를 추출하고 정렬
			const tasks = response.data.data.map(task => {
				// scheduleTime으로 정렬하기 위해 seconds 값 추출
				const scheduleSeconds = task.scheduleTime?.seconds || 0;
				return {
					...task,
					_sortTime: scheduleSeconds // 정렬용 필드 추가
				};
			});
			
			// 예약 시간 순으로 정렬 (가장 빠른 시간부터)
			tasks.sort((a, b) => a._sortTime - b._sortTime);
			
			return tasks;
		} else {
			console.warn("Unexpected API response structure:", response.data);
			return [];
		}
	} catch (error) {
		console.error("Error fetching scheduled posts:", error.response ? error.response.data : error.message);
		throw error;
	}
};

/**
 * @deprecated HTTP API 방식 - 사용하지 않음
 * Firestore 기반으로 대체됨: updateFirestoreTask() 사용
 */
export const updateScheduledPost = async (taskId, { text, executeAt }) => {
	const token = localStorage.getItem("longLivedToken");
	const userID = localStorage.getItem("userID");

	if (!token) { // || !userID) { // userID 필요 여부 확인
		throw new Error("인증 정보(토큰 또는 사용자 ID)가 없습니다.");
	}
	// TODO: 백엔드에 실제 수정 API(/updateTask)가 있는지 확인 필요
	if (!updateTaskUrl) {
		console.warn("Update Task URL is not defined. Assuming update is done by delete + create.");
		// TODO: 삭제 후 생성 로직 구현 필요 (deleteScheduledPost + createTask 호출)
		throw new Error("Update functionality not fully implemented yet.");
	}
	try {
		// TODO: 수정 API가 userID, token 등을 요구하는지 확인 필요
		const response = await axios.put(`${updateTaskUrl}/${taskId}`, { // URL 및 메소드 확인 필요
			text: text,
			executeAt: executeAt,
			// token: token, // 필요 시 추가
			// userID: userID, // 필요 시 추가
			// replies: replies, // 자동 댓글 기능 미완성으로 주석 처리
		});
		return response.data;
	} catch (error) {
		console.error("Error updating scheduled post:", error.response ? error.response.data : error.message);
		throw error;
	}
};

/**
 * @deprecated HTTP API 방식 - 사용하지 않음
 * Firestore 기반으로 대체됨: deleteFirestoreTask() 사용
 */
export const deleteScheduledPost = async (taskId) => {
	// deleteTask API는 토큰이 필요한지 API 규칙에 명시되지 않았습니다.
	// 만약 필요하다면 아래 주석을 해제하고, 백엔드 API 구현을 확인해야 합니다.
	// const token = localStorage.getItem("longLivedToken"); // 필요 시 주석 해제
	// if (!token) {
	// 	throw new Error("인증 토큰이 없습니다.");
	// }
	try {
		// API 문서상 POST 요청, body에 taskName 전달
		// 만약 토큰이 필요하다면 headers나 body에 추가해야 할 수 있습니다.
		// 예: const response = await axios.post(deleteTaskUrl, { taskName: taskId, token: token });
		const response = await axios.post(deleteTaskUrl, {
			taskName: taskId
		});
		return response.data;
	} catch (error) {
		console.error("Error deleting scheduled post:", error.response ? error.response.data : error.message);
		throw error;
	}
};

// =============================================================================
// 🔥 새로운 Firestore 기반 함수들 (Phase A 구현)
// =============================================================================

/**
 * Firestore 기반 태스크 생성 (pending_tasks 컬렉션에 저장)
 * @param {Object} taskData - 태스크 데이터
 * @param {string} taskData.text - 게시할 텍스트
 * @param {string} taskData.executeAt - 실행 시간 (KST)
 * @param {Array} taskData.replies - 댓글 배열
 * @param {Array} taskData.media - 미디어 파일 배열 (선택사항)
 * @param {string} taskData.collectionId - 연결할 컬렉션 ID (선택사항)
 * @param {Object} taskData.createNewCollection - 새 컬렉션 생성 정보 (선택사항)
 * @param {boolean} taskData.autoAddToCollection - 자동 컬렉션 추가 여부
 * @returns {Promise<Object>} 생성된 태스크 정보
 */
export const createFirestoreTask = async ({ 
	text, 
	executeAt, 
	replies = [], 
	media = [], // 🔥 미디어 파라미터 추가
	collectionId = null, 
	createNewCollection = null, 
	autoAddToCollection = false 
}) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("인증 정보(토큰 또는 사용자 ID)가 없습니다.");
	}

	// 토큰을 항상 tokenUtils로 획득하여 최초 게시/예약과 동일 경로 사용
	const { getValidTokenForAPI } = await import('./tokenUtils');
	const token = await getValidTokenForAPI(userID);

	console.log("Creating Firestore task for user:", userID, {
		collectionId,
		createNewCollection: !!createNewCollection,
		autoAddToCollection,
		mediaCount: media.length,
		mediaInfo: media.map(m => ({
			fileName: m.fileName,
			type: m.type,
			size: m.size,
			url: m.url // 전체 URL 로깅
		}))
	});

	try {
		// pending_tasks 컬렉션에 저장 (Firestore 트리거 발동)
		const taskData = {
			text: text,
			executeAt: executeAt,
			replies: replies,
			media: media, // 🔥 미디어 데이터 추가
			token: token,
			status: "pending_creation",
			createdAt: Date.now(),
			autoAddToCollection: autoAddToCollection
		};

		// 컬렉션 정보 추가
		if (collectionId) {
			taskData.collectionId = collectionId;
		}
		if (createNewCollection) {
			taskData.createNewCollection = createNewCollection;
		}

	const taskRef = await dbService
		.collection('user')
		.doc(userID)
		.collection('pending_tasks')
		.add(taskData);

	console.log("✅ Firestore task created:", taskRef.id);

	const result = {
		code: 200,
		message: "SUCCESS",
		now: Date.now(),
		data: {
			taskId: taskRef.id,
			status: "pending_creation"
		}
	};
	result.__httpStatus = 200;
	return result;
} catch (error) {
	console.error("Error creating Firestore task:", error);
	throw error;
}
};

/**
 * Firestore 기반 활성 태스크 목록 조회 (active_tasks 컬렉션)
 * @returns {Promise<Array>} 활성 태스크 목록
 */
export const getFirestoreActiveTasks = async () => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	try {
		const snapshot = await dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.orderBy('executeAt', 'asc')
			.get();

		const tasks = snapshot.docs.map(doc => ({
			id: doc.id,
			...doc.data(),
			// Cloud Tasks 형식과 호환성을 위한 변환
			name: doc.data().cloudTaskId || `firestore-task-${doc.id}`,
			scheduleTime: {
				seconds: Math.floor(new Date(doc.data().executeAt + ' GMT+0900').getTime() / 1000)
			},
			createTime: {
				seconds: Math.floor(doc.data().createdAt / 1000)
			}
		}));

		console.log(`✅ Found ${tasks.length} active Firestore tasks`);
		return tasks;
	} catch (error) {
		console.error("Error fetching Firestore active tasks:", error);
		throw error;
	}
};

/**
 * Firestore 기반 완료된 태스크 목록 조회 (completed_tasks 컬렉션)
 * @param {number} limit - 조회할 최대 개수 (기본: 20)
 * @returns {Promise<Array>} 완료된 태스크 목록
 */
export const getFirestoreCompletedTasks = async (limit = 20) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	try {
		const snapshot = await dbService
			.collection('user')
			.doc(userID)
			.collection('completed_tasks')
			.orderBy('completedAt', 'desc')
			.limit(limit)
			.get();

		const tasks = snapshot.docs.map(doc => ({
			id: doc.id,
			...doc.data()
		}));

		console.log(`✅ Found ${tasks.length} completed Firestore tasks`);
		return tasks;
	} catch (error) {
		console.error("Error fetching Firestore completed tasks:", error);
		throw error;
	}
};

/**
 * Firestore 기반 태스크 삭제 (active_tasks에서 삭제)
 * @param {string} taskId - 삭제할 태스크 ID
 * @returns {Promise<Object>} 삭제 결과
 */
export const deleteFirestoreTask = async (taskId) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	try {
		// 1. active_tasks에서 태스크 정보 가져오기
		const taskRef = dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.doc(taskId);

		const taskSnap = await taskRef.get();
		if (!taskSnap.exists) {
			throw new Error("태스크를 찾을 수 없습니다.");
		}

		const taskData = taskSnap.data();

		// 2. Cloud Task도 삭제 (기존 HTTP API 사용)
		if (taskData.cloudTaskId) {
			try {
				await deleteScheduledPost(taskData.cloudTaskId);
				console.log("✅ Cloud Task deleted:", taskData.cloudTaskId);
			} catch (cloudError) {
				console.warn("Cloud Task 삭제 실패:", cloudError.message);
				// Cloud Task 삭제 실패해도 Firestore 삭제는 진행
			}
		}

		// 3. Firestore에서 태스크 삭제
		await taskRef.delete();

		console.log("✅ Firestore task deleted:", taskId);

		return {
			code: 200,
			message: "SUCCESS",
			now: Date.now(),
			data: {
				taskId: taskId,
				status: "deleted"
			}
		};
	} catch (error) {
		console.error("Error deleting Firestore task:", error);
		throw error;
	}
};

/**
 * 사용자 태스크 메타데이터 조회
 * @returns {Promise<Object>} 메타데이터
 */
export const getFirestoreTaskMetadata = async () => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	try {
		const metaRef = dbService
			.collection('user')
			.doc(userID)
			.collection('metadata')
			.doc('tasks');

		const metaSnap = await metaRef.get();
		
		if (!metaSnap.exists) {
			// 메타데이터가 없으면 기본값 반환
			return {
				totalTasks: 0,
				scheduledTasks: 0,
				completedTasks: 0,
				failedTasks: 0,
				lastActivity: null
			};
		}

		return metaSnap.data();
	} catch (error) {
		console.error("Error fetching task metadata:", error);
		throw error;
	}
};

// =============================================================================
// 🔥 Phase B: 관리 기능 - 강화된 삭제 기능
// =============================================================================

/**
 * 배치 태스크 삭제 (여러 개 동시 삭제)
 * @param {Array} taskIds - 삭제할 태스크 ID 배열
 * @param {string} reason - 삭제 사유
 * @returns {Promise<Object>} 삭제 결과
 */
export const deleteFirestoreTasksBatch = async (taskIds) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	if (!Array.isArray(taskIds) || taskIds.length === 0) {
		throw new Error("삭제할 태스크 ID 배열이 유효하지 않습니다.");
	}

	console.log(`🗑️ Batch deleting ${taskIds.length} tasks for user ${userID}`);

	try {
		const results = {
			success: [],
			failed: [],
			cloudTasksDeleted: 0
		};

		// 각 태스크를 순차적으로 처리 (Firestore 배치 제한 고려)
		for (const taskId of taskIds) {
			try {
				const result = await deleteFirestoreTask(taskId);
				results.success.push({
					taskId,
					result
				});
			} catch (error) {
				console.error(`Failed to delete task ${taskId}:`, error);
				results.failed.push({
					taskId,
					error: error.message
				});
			}
		}

		console.log(`✅ Batch deletion completed: ${results.success.length} success, ${results.failed.length} failed`);

		return {
			code: 200,
			message: "BATCH_DELETE_COMPLETED",
			now: Date.now(),
			data: results
		};
	} catch (error) {
		console.error("Error in batch task deletion:", error);
		throw error;
	}
};

/**
 * 선택된 태스크들 삭제
 * @param {Array} selectedTasks - 선택된 태스크 객체 배열
 * @returns {Promise<Object>} 삭제 결과
 */
export const deleteSelectedTasks = async (selectedTasks) => {
	if (!Array.isArray(selectedTasks) || selectedTasks.length === 0) {
		throw new Error("선택된 태스크가 없습니다.");
	}

	const taskIds = selectedTasks.map(task => task.id);
	const taskTitles = selectedTasks.map(task => 
		task.text?.substring(0, 30) + (task.text?.length > 30 ? '...' : '')
	);

	console.log(`🎯 Deleting selected tasks:`, taskTitles);

	return await deleteFirestoreTasksBatch(taskIds);
};

/**
 * 만료된 태스크 자동 정리
 * @param {number} expiredHours - 만료 기준 시간 (기본: 24시간)
 * @returns {Promise<Object>} 정리 결과
 */
export const cleanupExpiredTasks = async (expiredHours = 24) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	try {
		const now = Date.now();
		const expiredThreshold = now - (expiredHours * 60 * 60 * 1000);

		console.log(`🧹 Cleaning up expired tasks (older than ${expiredHours} hours)`);

		// 만료된 태스크 찾기
		const snapshot = await dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.where('scheduledAt', '<', expiredThreshold)
			.get();

		if (snapshot.empty) {
			console.log('ℹ️ No expired tasks found');
			return {
				code: 200,
				message: "NO_EXPIRED_TASKS",
				now: Date.now(),
				data: { expiredCount: 0 }
			};
		}

		const expiredTaskIds = snapshot.docs.map(doc => doc.id);
		console.log(`Found ${expiredTaskIds.length} expired tasks`);

		const result = await deleteFirestoreTasksBatch(expiredTaskIds);

		return {
			code: 200,
			message: "CLEANUP_COMPLETED",
			now: Date.now(),
			data: {
				expiredCount: expiredTaskIds.length,
				cleanupResult: result.data
			}
		};
	} catch (error) {
		console.error("Error cleaning up expired tasks:", error);
		throw error;
	}
};

/**
 * 모든 활성 태스크 삭제 (사용자 요청)
 * @returns {Promise<Object>} 삭제 결과
 */
export const deleteAllActiveTasks = async () => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	const confirmMessage = "정말로 모든 예약된 태스크를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.";
	if (!window.confirm(confirmMessage)) {
		throw new Error("사용자가 취소했습니다.");
	}

	try {
		console.log(`🗑️ Deleting all active tasks for user ${userID}`);

		// 모든 활성 태스크 가져오기
		const snapshot = await dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.get();

		if (snapshot.empty) {
			return {
				code: 200,
				message: "NO_TASKS_TO_DELETE",
				now: Date.now(),
				data: { deletedCount: 0 }
			};
		}

		const allTaskIds = snapshot.docs.map(doc => doc.id);
		console.log(`Found ${allTaskIds.length} active tasks to delete`);

		const result = await deleteFirestoreTasksBatch(allTaskIds);

		return {
			code: 200,
			message: "ALL_TASKS_DELETED",
			now: Date.now(),
			data: {
				totalCount: allTaskIds.length,
				deleteResult: result.data
			}
		};
	} catch (error) {
		console.error("Error deleting all active tasks:", error);
		throw error;
	}
};

// =============================================================================
// 🔥 Phase B2: 태스크 수정 기능 (삭제→재생성 방식)
// =============================================================================

/**
 * 태스크 수정 (기존 태스크 삭제 후 새로 생성)
 * @param {string} taskId - 수정할 태스크 ID
 * @param {Object} newTaskData - 새로운 태스크 데이터
 * @param {string} newTaskData.text - 새로운 텍스트
 * @param {string} newTaskData.executeAt - 새로운 실행 시간
 * @param {Array} newTaskData.replies - 새로운 댓글 배열
 * @returns {Promise<Object>} 수정 결과
 */
export const updateFirestoreTask = async (taskId, newTaskData) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	if (!taskId || !newTaskData) {
		throw new Error("태스크 ID와 새로운 데이터가 필요합니다.");
	}

	console.log(`✏️ Updating task ${taskId} for user ${userID}`);

	try {
		// 1. 기존 태스크 정보 가져오기
		const taskRef = dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.doc(taskId);

		const taskSnap = await taskRef.get();
		if (!taskSnap.exists) {
			throw new Error("수정할 태스크를 찾을 수 없습니다.");
		}

		const originalTask = taskSnap.data();
		console.log(`📋 Original task found:`, originalTask.text?.substring(0, 50));

		// 2. 새로운 태스크 생성 (원본의 media/컬렉션 설정 유지)
		console.log(`📝 Creating new task with updated data...`);
		const mergedMedia =
			newTaskData.media !== undefined
				? newTaskData.media
				: (originalTask.media || []);

		const mergedReplies =
			newTaskData.replies !== undefined
				? newTaskData.replies
				: (originalTask.replies || []);

		const createPayload = {
			text: newTaskData.text,
			executeAt: newTaskData.executeAt,
			replies: Array.isArray(mergedReplies) ? mergedReplies : [],
			media: Array.isArray(mergedMedia) ? mergedMedia : [],
			collectionId: newTaskData.collectionId ?? originalTask.collectionId ?? null,
			createNewCollection: newTaskData.createNewCollection ?? originalTask.createNewCollection ?? null,
			autoAddToCollection: newTaskData.autoAddToCollection ?? originalTask.autoAddToCollection ?? false
		};

		const createResult = await createFirestoreTask(createPayload);
		const newTaskId = createResult?.data?.taskId;
		console.log(`🆕 Pending task created: ${newTaskId}`);

		let deleteError = null;
		try {
			// 3. 기존 태스크 삭제 (Cloud Task 포함)
			console.log(`🗑️ Deleting original task...`);
			await deleteFirestoreTask(taskId);
		} catch (error) {
			deleteError = error;
			console.error('❌ Failed to delete original task. Rolling back new task if possible.', error);
			if (newTaskId) {
				try {
					await dbService
						.collection('user')
						.doc(userID)
						.collection('pending_tasks')
						.doc(newTaskId)
						.delete();
					console.log(`🧹 Rolled back pending task ${newTaskId}`);
				} catch (rollbackError) {
					console.warn('⚠️ Failed to rollback pending task:', rollbackError);
				}
			}
		}

		if (deleteError) {
			throw deleteError;
		}

		console.log(`✅ Task updated successfully`);

		return {
			code: 200,
			message: "TASK_UPDATED_SUCCESS",
			now: Date.now(),
			data: {
				originalTaskId: taskId,
				newTaskId: newTaskId,
				changes: {
					text: {
						from: originalTask.text,
						to: newTaskData.text
					},
					executeAt: {
						from: originalTask.executeAt,
						to: newTaskData.executeAt
					},
					replies: {
						from: originalTask.replies || [],
						to: newTaskData.replies || []
					},
					media: {
						from: originalTask.media || [],
						to: createPayload.media
					}
				}
			}
		};
	} catch (error) {
		console.error("Error updating task:", error);
		throw error;
	}
};

/**
 * 태스크 복사 (기존 태스크를 기반으로 새 태스크 생성)
 * @param {string} taskId - 복사할 태스크 ID
 * @param {Object} modifications - 수정할 항목들 (optional)
 * @returns {Promise<Object>} 복사 결과
 */
export const duplicateFirestoreTask = async (taskId, modifications = {}) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	console.log(`📋 Duplicating task ${taskId} for user ${userID}`);

	try {
		// 1. 원본 태스크 정보 가져오기
		const taskRef = dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.doc(taskId);

		const taskSnap = await taskRef.get();
		if (!taskSnap.exists) {
			throw new Error("복사할 태스크를 찾을 수 없습니다.");
		}

		const originalTask = taskSnap.data();

		// 2. 새로운 태스크 데이터 구성
		const newTaskData = {
			text: modifications.text || originalTask.text,
			executeAt: modifications.executeAt || originalTask.executeAt,
			replies: (modifications.replies || originalTask.replies || []).map(r => String(r)),
			media: modifications.media || originalTask.media || [],
			collectionId: modifications.collectionId ?? originalTask.collectionId ?? null,
			createNewCollection: modifications.createNewCollection ?? originalTask.createNewCollection ?? null,
			autoAddToCollection: modifications.autoAddToCollection ?? originalTask.autoAddToCollection ?? false
		};

		// 3. 새로운 태스크 생성
		console.log(`📝 Creating duplicate task...`);
		const createResult = await createFirestoreTask(newTaskData);

		console.log(`✅ Task duplicated successfully`);

		return {
			code: 200,
			message: "TASK_DUPLICATED_SUCCESS",
			now: Date.now(),
			data: {
				originalTaskId: taskId,
				duplicatedTaskId: createResult.data.taskId,
				taskData: newTaskData
			}
		};
	} catch (error) {
		console.error("Error duplicating task:", error);
		throw error;
	}
};

/**
 * 태스크 시간 연기
 * @param {string} taskId - 연기할 태스크 ID
 * @param {number} delayMinutes - 연기할 시간 (분)
 * @returns {Promise<Object>} 연기 결과
 */
export const postponeFirestoreTask = async (taskId, delayMinutes) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	if (!delayMinutes || delayMinutes <= 0) {
		throw new Error("유효한 연기 시간을 입력해주세요.");
	}

	console.log(`⏰ Postponing task ${taskId} by ${delayMinutes} minutes`);

	try {
		// 1. 기존 태스크 정보 가져오기
		const taskRef = dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.doc(taskId);

		const taskSnap = await taskRef.get();
		if (!taskSnap.exists) {
			throw new Error("연기할 태스크를 찾을 수 없습니다.");
		}

		const originalTask = taskSnap.data();
		
		// 2. 새로운 실행 시간 계산
		const originalDate = new Date(originalTask.executeAt + ' GMT+0900');
		const newDate = new Date(originalDate.getTime() + (delayMinutes * 60 * 1000));
		
		const year = newDate.getFullYear();
		const month = String(newDate.getMonth() + 1).padStart(2, "0");
		const day = String(newDate.getDate()).padStart(2, "0");
		const hours = String(newDate.getHours()).padStart(2, "0");
		const minutes = String(newDate.getMinutes()).padStart(2, "0");
		const seconds = "00";

		const newExecuteAt = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

		// 3. 태스크 업데이트 (삭제 후 재생성)
		const updateResult = await updateFirestoreTask(taskId, {
			text: originalTask.text,
			executeAt: newExecuteAt,
			replies: (originalTask.replies || []).map(r => String(r)),
			media: originalTask.media || [],
			collectionId: originalTask.collectionId ?? null,
			createNewCollection: originalTask.createNewCollection ?? null,
			autoAddToCollection: originalTask.autoAddToCollection ?? false
		});

		console.log(`✅ Task postponed successfully to ${newExecuteAt}`);

		return {
			code: 200,
			message: "TASK_POSTPONED_SUCCESS",
			now: Date.now(),
			data: {
				taskId: taskId,
				originalTime: originalTask.executeAt,
				newTime: newExecuteAt,
				delayMinutes: delayMinutes,
				updateResult: updateResult.data
			}
		};
	} catch (error) {
		console.error("Error postponing task:", error);
		throw error;
	}
};

/**
 * 태스크 즉시 실행 (예약 취소 후 즉시 게시)
 * @param {string} taskId - 즉시 실행할 태스크 ID
 * @returns {Promise<Object>} 실행 결과
 */
export const executeFirestoreTaskImmediately = async (taskId) => {
	const userID = localStorage.getItem("userID");

	if (!userID) {
		throw new Error("사용자 ID가 없습니다.");
	}

	console.log(`⚡ Executing task ${taskId} immediately`);

	try {
		// 1. 태스크 정보 가져오기
		const taskRef = dbService
			.collection('user')
			.doc(userID)
			.collection('active_tasks')
			.doc(taskId);

		const taskSnap = await taskRef.get();
		if (!taskSnap.exists) {
			throw new Error("실행할 태스크를 찾을 수 없습니다.");
		}

		const taskData = taskSnap.data();

		// 2. 예약 태스크 삭제
		console.log(`🗑️ Canceling scheduled task...`);
		await deleteFirestoreTask(taskId);

		// 3. 즉시 게시 실행
		console.log(`📤 Posting thread immediately...`);
		const postResult = await postThread(
			taskData.text,
			(taskData.replies || []).map(r => String(r)),
			taskData.media || [],
			taskId
		);

		console.log(`✅ Task executed immediately`);

		return {
			code: 200,
			message: "TASK_EXECUTED_IMMEDIATELY",
			now: Date.now(),
			data: {
				originalTaskId: taskId,
				postResult: postResult,
				originalScheduleTime: taskData.executeAt
			}
		};
	} catch (error) {
		console.error("Error executing task immediately:", error);
		throw error;
	}
};
